import { sendRequest, handleSessionChange, getJSON, checkExpired } from './utils';
import { FetchConfig } from 'types';
import Auth from './auth/index';
import { BASE_URLS, CLIENT_IDS, REDIRECT_URLS } from './auth/constants';
import HTTPMethods from './utils/http';

interface RefreshTokenResponse {
	access_token: string;
	refresh_token: string;
}

export const refreshAccessToken = async (
	refreshToken: string
): Promise<RefreshTokenResponse> => {
	const env: string = (window as any).Stash?.env || process.env.NODE_ENV;
	const root = BASE_URLS[env];
	const client_id = CLIENT_IDS[env];
	const redirect_uri = REDIRECT_URLS[env];
	const tokenConfig = {
		method: HTTPMethods.POST,
		headers: {
			Accept: 'application/json',
		},
		body: {
			refresh_token: refreshToken.replace('Bearer ', ''),
		},
	};
	const tokenUrl = `${root}api/v1/token?grant_type=refresh_token&client_id=${client_id}&redirect_uri=${redirect_uri}`;
	const newAuth = await sendRequest(tokenUrl, tokenConfig);
	if (!newAuth.ok) {
		Auth.logOut('refresh token failed');
	}
	const payload: RefreshTokenResponse = await getJSON(newAuth);
	Auth.set({
		accessToken: 'Bearer ' + payload.access_token,
		refreshToken: payload.refresh_token,
	});

	return new Promise((resolve) => resolve(payload));
};

const createFetchHandler = (url: string, config: FetchConfig) => {
	const fetchHandler = async () => {
		const authParams = Auth.get();
		const { accessToken, refreshToken } = authParams;

		if (checkExpired(accessToken)) {
			if (refreshToken) {
				const payload: any = await refreshAccessToken(refreshToken);
				config.accessToken = 'Bearer ' + payload.access_token;
				const response = await sendRequest(url, config);
				const json = await getJSON(response);
				await handleSessionChange(json);
				return json;
			} else {
				Auth.logOut('missing refresh token');
			}
		} else {
			let response = await sendRequest(url, config);
			if (response.status === 401) {
				if (refreshToken) {
					const payload: RefreshTokenResponse = await refreshAccessToken(refreshToken);

					config.accessToken = 'Bearer ' + payload.access_token;
					response = await sendRequest(url, config);
				} else {
					Auth.logOut('missing refresh token');
				}
			}
			const json = await getJSON(response);
			await handleSessionChange(json);
			return json;
		}
	};
	return fetchHandler;
};

export default createFetchHandler;
